module.exports = __webpack_public_path__ + "static/img/function3.b4c96d81.png";